import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { LIGHT_BLUE, WHITE, BLUE_HOVER } from "../../../../../styles/color";

export const HeaderLayout = styled.header`
  grid-area: header;
  min-width: 0;
  background: ${WHITE};
  border-bottom: 1px solid #e2e8f0;
`;

export const HeaderTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 24px;
  padding: 16px 40px;

  @media (max-width: 1100px) {
    padding: 14px 24px;
  }
`;

export const HeaderBrand = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  box-sizing: border-box;
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;

  > img {
    display: block;
    width: 240px;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const CategoryNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

export const CategoryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 12px;
  border: 1px solid ${({ $open, $active }) => ($open || $active ? LIGHT_BLUE : "transparent")};
  border-radius: 8px;
  background: ${({ $active, $open }) => ($active ? LIGHT_BLUE : $open ? "#eff8ff" : "transparent")};
  color: ${({ $active }) => ($active ? WHITE : "#334155")};
  font: inherit;
  font-size: 14px;
  line-height: 1.4;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background: ${({ $active }) => ($active ? BLUE_HOVER : "#eff8ff")};
  }

  &:focus-visible {
    outline: 2px solid ${BLUE_HOVER};
    outline-offset: 2px;
  }
`;

export const SubMenuPanel = styled.nav`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 40px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;

  @media (max-width: 1100px) {
    padding: 10px 24px;
  }
`;

export const MenuLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 40px;
  box-sizing: border-box;
  padding: 8px 14px;
  border-radius: 6px;
  color: #334155;
  text-decoration: none;
  font-size: 14px;
  line-height: 1.4;

  > span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }

  img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  &[aria-current="page"] {
    background: ${LIGHT_BLUE};
    color: ${WHITE};
    font-weight: 600;
  }

  &:hover {
    background: #e0f2fe;
    color: ${BLUE_HOVER};
  }

  &:focus-visible {
    outline: 2px solid ${BLUE_HOVER};
    outline-offset: 2px;
  }
`;
